import React, { Component } from "react";
//import Script from 'react-load-script'
//import { FaPhone, FaFacebookSquare } from 'react-icons/fa'
//import { MdEmail } from 'react-icons/md'
import Iframe from "react-iframe";

class ContactForm extends Component {
	constructor(props) {
		super(props);
		this.state = { scriptLoaded: false };
	}
	handleScriptLoad() {
		this.setState({ scriptLoaded: true });
	}
	render() {
		/*var loading = <i className="fa fa-spinner"></i>
    if (this.state.scriptLoaded === true) {
      loading = ''
    }*/
		return (
			<section>
				<header id="page-title">
					<div className="container">
						<h1>Connection Card</h1>
					</div>
				</header>
				<section className="container">
					<Iframe
						url="https://crckingston.elvanto.com.au/form/56bcd51c-618d-4524-a53f-2d771a1ff63d"
						width="100%"
						height="1575px"
						position="relative"
					/>
				</section>
			</section>
		);
	}
}

export default ContactForm;
